//import * as d3 from "d3";
import store from "../store";
import axios from "axios";
import * as _ from "lodash";

export default {
  getData: async function() {
    axios
      .get(store.state.host + "api/v1/publicReports", {
        params: {}
      })
      .then(response => {
        let allVictims = [];
        response.data.result.forEach(el => {
          if (el.attention.attentionDate) {
            el.year = el.attention.attentionDate.slice(0,4);
          }
          if (el.victims.length > 0) {
            el.victims.forEach(v => {
              if (v.lastSeenDate) {
                v.year = v.lastSeenDate.slice(0,4);
              }
              v.advisoryFolio = el.folio;
            });
            allVictims = allVictims.concat(el.victims);
          }
        });
        store.commit("setReports", response.data.result);
        store.commit("setVictims", allVictims);
        this.filterData();
      })
      .catch(error => {
        console.log(error);
      });
  },
  filterData() {
    let filteredReports = store.state.reports;
    let filteredVictims = store.state.victims;

    if (
      store.state.filters.matters &&
      store.state.filters.matters !== "Todos"
    ) {
      filteredReports = filteredReports.filter(report => {
        if (report.synthesis.matter) {
          return report.synthesis.matter[store.state.filters.matters].isSelected;
        }
      });
    }
    //console.log(filteredReports, "matters");

    if (store.state.filters.state && store.state.filters.state !== "Todos") {
      filteredReports = filteredReports.filter(report => {
        if (report.synthesis.state) {
          return report.synthesis.state === store.state.filters.state;
        }
      });
    }
    //console.log(filteredReports, "state");

    if (
      store.state.filters.period &&
      (store.state.filters.period[0] !== store.state.min || store.state.filters.period[1] !== store.state.max)
    ) {
      console.log("filter period");
      console.log(store.state.filters.period[0], '-', store.state.min, ' >-< ', store.state.filters.period[1], '-', store.state.max);
      filteredReports = filteredReports.filter(report => {
        return report.year >= store.state.filters.period[0] && report.year <= store.state.filters.period[1];
      });
    }


    if (
      (store.state.filters.firstAge && store.state.filters.firstAge !== "") &&
      (store.state.filters.secondAge && store.state.filters.secondAge !== "")
    ) {
      filteredReports = filteredReports.filter(report => {
        if (report.petitioner.age){
          return report.petitioner.age >= store.state.filters.firstAge && report.petitioner.age <= store.state.filters.secondAge;
        }
      });
    } else if (store.state.filters.firstAge && store.state.filters.firstAge !== "") {
      filteredReports = filteredReports.filter(report => {
        if (report.petitioner.age){
          return report.petitioner.age >= store.state.filters.firstAge;
        }
      });
    } else if (store.state.filters.secondAge && store.state.filters.secondAge !== "") {
      filteredReports = filteredReports.filter(report => {
        if (report.petitioner.age){
          return report.petitioner.age <= store.state.filters.secondAge;
        }
      });
    }
    //console.log(filteredReports, "age");

    if (
      store.state.filters.sex &&
      store.state.filters.sex !== "Todos"
    ) {
      filteredReports = filteredReports.filter(report => {
        if (report.petitioner.sex) {
          return report.petitioner.sex === store.state.filters.sex;
        }
      });
    }

    //console.log(filteredReports, "sex");

    if (
      store.state.filters.occupation &&
      store.state.filters.occupation !== "Todas"
    ) {
      filteredReports = filteredReports.filter(report => {
        if (report.petitioner.occupation){
          return report.petitioner.occupation === store.state.filters.occupation;
        }
      });
    }

    if (
      store.state.filters.civilStatus &&
      store.state.filters.civilStatus !== "Todos"
    ) {
      filteredReports = filteredReports.filter(report => {
        if (report.petitioner.civilStatus){
          return report.petitioner.civilStatus === store.state.filters.civilStatus;
        }
      });
    }

    if (
      store.state.filters.intervention &&
      store.state.filters.intervention !== "Todas"
    ) {
      filteredReports = filteredReports.filter(report => {
        if (report.synthesis.intervention){
          return report.synthesis.intervention[store.state.filters.intervention].isSelected;
        }
      });
    }

    if (
      store.state.filters.referred &&
      store.state.filters.referred !== "Todas"
    ) {
      filteredReports = filteredReports.filter(report => {
        if (report.synthesis.referred){
          return report.synthesis.referred[store.state.filters.referred].isSelected;
        }
      });
    }

    if (store.state.filters.municipality && store.state.filters.municipality !== "Todos") {
      filteredReports = filteredReports.filter(report => {
        if (report.synthesis.municipality) {
          return report.synthesis.municipality === store.state.filters.municipality;
        }
      });
    }

    // Victim filters

    if (
      store.state.filters.lastSeenPlace &&
      store.state.filters.lastSeenPlace !== "Todos"
    ) {
      filteredVictims = filteredVictims.filter(victim => {
        return victim.disappearancePlace === store.state.filters.lastSeenPlace;
      });
    }

    if (
      store.state.filters.status &&
      store.state.filters.status !== "Todos"
    ) {
      filteredVictims = filteredVictims.filter(victim => {
        return victim.status === store.state.filters.status;
      });
    }

    if (
      store.state.filters.victimYears
    ) {
      filteredVictims = filteredVictims.filter(victim => {
        return victim.year >= store.state.filters.victimYears[0] && victim.year <= store.state.filters.victimYears[1];
      });
    }

    if (
      (store.state.filters.firstVictimAge && store.state.filters.firstVictimAge !== "") &&
      (store.state.filters.secondVictimAge && store.state.filters.secondVictimAge !== "")
    ) {
      filteredVictims = filteredVictims.filter(victim => {
        return victim.age >= store.state.filters.firstVictimAge && victim.age <= store.state.filters.secondVictimAge;
      });
    } else if (store.state.filters.firstVictimAge && store.state.filters.firstVictimAge !== "") {
      filteredVictims = filteredVictims.filter(victim => {
        return victim.age >= store.state.filters.firstVictimAge;
      });
    } else if (store.state.filters.secondVictimAge && store.state.filters.secondVictimAge !== "") {
      filteredVictims = filteredVictims.filter(victim => {
        return victim.age <= store.state.filters.secondVictimAge;
      });
    }

    if (
      store.state.filters.victimSex &&
      store.state.filters.victimSex !== "Todos"
    ) {
      filteredVictims = filteredVictims.filter(victim => {
        return victim.sex === store.state.filters.victimSex;
      });
    }

    //console.log(filteredReports, "final");
    store.commit("setFilteredReports", filteredReports);
    store.commit("setFilteredVictims", filteredVictims);

    const filteredStates = [...new Set([...filteredReports.map(el => {
      return el.synthesis.state;
    })])].sort();
    const filteredVictimsStates = [...new Set([...filteredVictims.map(el => {
      return el.disappearancePlace;
    })])].sort();

    store.commit("setFilteredStates", filteredStates);
    store.commit("setFilteredVictimsStates", filteredVictimsStates);
    store.commit("setSelection", undefined);
    store.commit("setVictimSelection", undefined);
  }
};
